// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'

// import('../node_modules/vuetify/dist/vuetify.min.css')
import Vuetify from 'vuetify'

import App from '@/App'
import router from '@/router'
import store from '@/vuex/store'

Vue.config.productionTip = false
Vue.use(Vuetify)
Vue.directive('focus', {
  // 바인딩 된 엘리먼트가 DOM에 삽입되었을 때
  inserted: function (el) {
    // 엘리먼트에 포커스를 줌
    el.focus()
  }
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js